import { render, staticRenderFns } from "./EditTextFontStyle.vue?vue&type=template&id=0e4c7425&"
import script from "./EditTextFontStyle.vue?vue&type=script&lang=js&"
export * from "./EditTextFontStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports